import React from 'react';

import { useTranslation } from "react-i18next";
import styled from 'styled-components';

import { useBreakpoints } from '@hooks/NewBreakpoint';

const Filter = styled.div`
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #43b02a;
  margin-right: 16px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const CleanFilter = ({ onClickCleanFilter }) => {
  const { breakpoint } = useBreakpoints();
  const { t } = useTranslation();
  return (
    <Filter onClick={onClickCleanFilter} testId="onClickButton">
      {' '}
      {['xs', 'sm', 'ss', 'smm'].includes(breakpoint) ? t("lastMovements.clean") : t("lastMovements.cleanFilters")}
    </Filter>
  );
};

export default CleanFilter;
